import gql from 'graphql-tag'
import snackbar from './snackbar'
import tenant from './tenant'

const root = gql`
  type Query {
    root: String
  }
  type Mutation {
    root: String
  }
`

const typeDefs = [root, snackbar.typeDefs, tenant.typeDefs]

const Query = {
  ...snackbar.resolvers.Query,
  ...tenant.resolvers.Query
}

const Mutation = {
  ...snackbar.resolvers.Mutation,
  ...tenant.resolvers.Mutation
}

export default {
  typeDefs,
  resolvers: {
    Query,
    Mutation
  },
  hydrate: {
    ...snackbar.hydrate,
    ...tenant.hydrate
  }
}
